import Companylogo from "../companylogo_Alter1.svg";
import Sitelogo from "../companylogo_Alter1.svg";
const GlobalData = {
  company: {
    companyName: "shivamshippingandlogistics-scm",
    companyPhone: "+917016210802 ",
    companyEmail: "business@sslscm.com",
    companyAddress: "Visakhapatnam, Andhra Pradesh 530017",
    companyWhatsapp: "https://api.whatsapp.com/send?phone=+917898013338 ",

    /*Social media */
    companyfacebook: "https://www.facebook.com/shivamshipping/",
    companyinstagram: "https://www.instagram.com/shivamshipping/",
    companygit: "https://github.com/shivamshipping/",
    companytwitter: "https://twitter.com/shivamshipping/",
  },
};

export { GlobalData, Companylogo,Sitelogo };
